export default __webpack_public_path__ + "static/media/771.17c4edbe.gif";